import { ResourceOptions } from "react-admin";
import { FaCloudUploadAlt } from "react-icons/fa";
import { Resources } from "../../resource";

export { default as list } from './List';

export const name = Resources.cdnUpload;
export const icon = FaCloudUploadAlt;
export const options: ResourceOptions = {
    label: 'resource.cdnUpload',
}